import React from 'react'
import { revenueCodesAndNames,expenditureCodesAndNames, sumOfArray, formatToZMW } from '../../../../helpers'
import { useOutletContext } from 'react-router-dom'

const Randcs = ({ currentYearData, previousYearData, sof, startDate}) => {

let count = 0;

const {allData, setAllData} = useOutletContext();
const currentYear = startDate ? new Date(startDate).getFullYear() : new Date().getFullYear();
const previousYear = currentYear - 1;
const expenditureCodeIds = expenditureCodesAndNames.map((c) => c.id);
const sof3Payments = sof === 3 ? (() => {
  const grouped = {};
  const addToGroup = (items, isCurrentYear) => {
    items
      .filter((item) => item.type === 'expense' && expenditureCodeIds.includes(String(item?.coa || '').substring(0, 3)))
      .forEach((item) => {
        const subprogramName = allData.subProgram.find(
          (data) => data.subProgramCode == item?.subprogram && data.programCode == item?.program
        )?.name || 'Unassigned Subprogram';
        if (!grouped[subprogramName]) {
          grouped[subprogramName] = { key: subprogramName, label: subprogramName, currSum: 0, prevSum: 0 };
        }
        if (isCurrentYear) {
          grouped[subprogramName].currSum += parseFloat(item.amount) || 0;
        } else {
          grouped[subprogramName].prevSum += parseFloat(item.amount) || 0;
        }
      });
  };

  addToGroup(currentYearData, true);
  addToGroup(previousYearData, false);

  return Object.values(grouped).filter((row) => (row.currSum || 0) !== 0 || (row.prevSum || 0) !== 0);
})() : [];

  return (
    <div className="space-y-8 my-5">
         <hr className="border-t-2 border-slate-200 py-5" />
      <h1 className='text-2xl font-bold text-slate-800'>THE STATEMENT OF CASH RECEIPTS AND PAYMENTS {sof===2?`FOR THE LOCAL GOVERNMENT
EQUALISATION FUND (LGEF)`:sof===3?`FOR CONSTITUENCY DEVELOPMENT
FUND`:sof===7?`FOR THE SECTOR GRANT (DELEGATED FUNCTION) `:``} FOR THE YEAR ENDED 31ST DECEMBER {currentYear}</h1>
      
      <table className="w-full table-auto border-collapse shadow-sm rounded-lg overflow-hidden">
        <thead className="bg-blue-950 text-white">
          <tr>
            <th className="text-left px-4 py-3 w-2/5"></th>
            <th className="text-center px-4 py-3 w-1/5">{sof===0?`Notes`:``}</th>
            <th className="text-right px-4 py-3 w-1/5">{currentYear}</th>
            <th className="text-right px-4 py-3 w-1/5">{previousYear}</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {/* Receipts section */}
          <tr className="bg-gray-100">
            <td className="px-4 py-2 font-semibold text-slate-700" colSpan={4}>Receipts</td>
          </tr>
          {revenueCodesAndNames.map((code) => {
            const currSum = sumOfArray(
              currentYearData
                .filter(data => String(data?.coa || '').substring(0, 3) === code.id && data.type === 'income')
                .map(data => parseFloat(data.amount))
            );
            const prevSum = sumOfArray(
              previousYearData
                .filter(data => String(data?.coa || '').substring(0, 3) === code.id && data.type === 'income')
                .map(data => parseFloat(data.amount))
            );

            if ((currSum || 0) === 0 && (prevSum || 0) === 0) return null;
            return (
              <tr key={code.id} className="odd:bg-gray-50">
                <td className="px-4 py-2 text-slate-800">{code.name}</td>
                <td className="px-4 py-2 text-center text-slate-600">{sof===0?++count:``}</td>
                <td className="px-4 py-2 text-right font-medium text-slate-800">{formatToZMW(currSum)}</td>
                <td className="px-4 py-2 text-right font-medium text-slate-800">{formatToZMW(prevSum)}</td>
              </tr>
            );
          })}
          {/* Total Receipts */}
          <tr className='bg-gray-600 font-semibold border-t border-gray-600 text-white'>
            <td className="px-4 py-3">Total Receipts</td>
            <td className="px-4 py-3"></td>
            <td className="px-4 py-3 text-right">{formatToZMW(sumOfArray(currentYearData
              .filter(data => revenueCodesAndNames.some(c => c.id === String(data?.coa || '').substring(0,3)) && data.type === 'income')
              .map(data => parseFloat(data.amount)))
            )}</td>
            <td className="px-4 py-3 text-right">{formatToZMW(sumOfArray(previousYearData
              .filter(data => revenueCodesAndNames.some(c => c.id === String(data?.coa || '').substring(0,3)) && data.type === 'income')
              .map(data => parseFloat(data.amount)))
            )}</td>
          </tr>

          {/* Payments section */}
          <tr className="bg-gray-300">
            <td className="px-4 py-2 font-semibold text-slate-700" colSpan={4}>Payments</td>
          </tr>
          {(sof === 3 ? sof3Payments : expenditureCodesAndNames.map((code) => {
            const currSum = sumOfArray(
              currentYearData
                .filter(data => String(data?.coa || '').substring(0, 3) === code.id && data.type === 'expense')
                .map(data => parseFloat(data.amount))
            );
            const prevSum = sumOfArray(
              previousYearData
                .filter(data => String(data?.coa || '').substring(0, 3) === code.id && data.type === 'expense')
                .map(data => parseFloat(data.amount))
            );
            return {
              key: code.id,
              label: code.name,
              currSum,
              prevSum
            };
          })).map((row) => {
            if ((row.currSum || 0) === 0 && (row.prevSum || 0) === 0) return null;
            return (
              <tr key={row.key} className="odd:bg-gray-50">
                <td className="px-4 py-2 text-slate-800">{row.label}</td>
                <td className="px-4 py-2 text-center text-slate-600">{sof===0?++count:``}</td>
                <td className="px-4 py-2 text-right font-medium text-slate-800">{formatToZMW(row.currSum)}</td>
                <td className="px-4 py-2 text-right font-medium text-slate-800">{formatToZMW(row.prevSum)}</td>
              </tr>
            );
          })}
          {/* Total Payments */}
          <tr className='bg-gray-600 font-semibold border-t border-gray-600 text-white'>
            <td className="px-4 py-3">Total Payments</td>
            <td className="px-4 py-3"></td>
            <td className="px-4 py-3 text-right">{formatToZMW(sumOfArray(currentYearData
              .filter(data => expenditureCodesAndNames.some(c => c.id === String(data?.coa || '').substring(0,3)) && data.type === 'expense')
              .map(data => parseFloat(data.amount)))
            )}</td>
            <td className="px-4 py-3 text-right">{formatToZMW(sumOfArray(previousYearData
              .filter(data => expenditureCodesAndNames.some(c => c.id === String(data?.coa || '').substring(0,3)) && data.type === 'expense')
              .map(data => parseFloat(data.amount)))
            )}</td>
          </tr>

          {/* Summary rows */}
          {(() => {
            const totalReceiptsCurrent = sumOfArray(currentYearData
              .filter(d => revenueCodesAndNames.some(c => c.id === String(d?.coa || '').substring(0,3)) && d.type === 'income')
              .map(d => parseFloat(d.amount)));
            const totalReceiptsPrev = sumOfArray(previousYearData
              .filter(d => revenueCodesAndNames.some(c => c.id === String(d?.coa || '').substring(0,3)) && d.type === 'income')
              .map(d => parseFloat(d.amount)));
            const totalPaymentsCurrent = sumOfArray(currentYearData
              .filter(d => expenditureCodesAndNames.some(c => c.id === String(d?.coa || '').substring(0,3)) && d.type === 'expense')
              .map(d => parseFloat(d.amount)));
            const totalPaymentsPrev = sumOfArray(previousYearData
              .filter(d => expenditureCodesAndNames.some(c => c.id === String(d?.coa || '').substring(0,3)) && d.type === 'expense')
              .map(d => parseFloat(d.amount)));
            const incDecCurrent = totalReceiptsCurrent - totalPaymentsCurrent;
            const incDecPrev = totalReceiptsPrev - totalPaymentsPrev;
            
            // Closing cash balance for previous year, based on bank balances
            const totalCashEndPrev = (allData.bank || []).reduce((total, bank) => {
              const prevIncome = previousYearData
                ?.filter(item => item.bank === bank.id && item.type === 'income')
                ?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || 0;

              const prevExpense = previousYearData
                ?.filter(item => item.bank === bank.id && item.type === 'expense')
                ?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || 0;

              const prevBalance = prevIncome - prevExpense;

              return total + prevBalance;
            }, 0) || 0;
            
            // Ensure: closing balance of previous year = opening balance of current year
            const cashBeginningPrev = totalCashEndPrev - incDecPrev;
            const cashBeginningCurrent = totalCashEndPrev;
            const totalCashEndCurrent = cashBeginningCurrent + incDecCurrent;

            return (
              <>
                <tr className='font-semibold'>
                  <td className="px-4 py-3">Increase/(decrease) in Cash</td>
                  <td className="px-4 py-3 text-center">{sof===0?++count:``}</td>
                  <td className="px-4 py-3 text-right">{formatToZMW(incDecCurrent)}</td>
                  <td className="px-4 py-3 text-right">{formatToZMW(incDecPrev)}</td>
                </tr>
                <tr>
                  <td className="px-4 py-2">Foreign Exchange Losses</td>
                  <td className="px-4 py-2 text-center">{sof===0?++count:``}</td>
                  <td className="px-4 py-2 text-right">-</td>
                  <td className="px-4 py-2 text-right">-</td>
                </tr>
                <tr>
                  <td className="px-4 py-2">Cash at beginning of the year</td>
                  <td className="px-4 py-2 text-center">{sof===0?++count:``}</td>
                  <td className="px-4 py-2 text-right">{formatToZMW(cashBeginningCurrent)}</td>
                  <td className="px-4 py-2 text-right">{formatToZMW(cashBeginningPrev)}</td>
                </tr>
                <tr>
                  <td className="px-4 py-2">Cash at the end of the year</td>
                  <td className="px-4 py-2 text-center">{sof===0?++count:``}</td>
                  <td className="px-4 py-2 text-right">{formatToZMW(totalCashEndCurrent)}</td>
                  <td className="px-4 py-2 text-right">{formatToZMW(totalCashEndPrev)}</td>
                </tr>
              </>
            );
          })()}
        </tbody>
      </table>


      <p className='text-sm text-slate-600 text-justify'>Incorporated in the payments recognised in this Statement are those for Local Government Equalisation and
Constituency Development Funds. However, the details of payments under each of these Funds are presented
separately in each Fund’s own Statement of Cash Receipts and Payments.</p>
    </div>
  )
}

export default Randcs